import { Box } from '@mui/material';
import React from 'react';
import { ShimmerThumbnail } from "react-shimmer-effects";

const OutletSkeleton = () => {
  return (
    <Box>
      <ShimmerThumbnail height={140} rounded />
      <ShimmerThumbnail height={140} rounded />
      <ShimmerThumbnail height={140} rounded />
    </Box>
  )
}

export default OutletSkeleton;
